import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactPage = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [gmail, setGmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!firstName || !lastName || !gmail) {
      toast.error("Please fill all the required fields!");
      return;
    }

    const payload = {
      firstName,
      lastName,
      email: gmail,
      phonenumber: mobileNumber,
      message,
      type: "contact"
    };

    try {
      const response = await axios.post(
        "https://tnreaders.in/web/contact",
        payload
      );
      if (response) {
        toast.success("Submitted Successfully");
        setFirstName("");
        setLastName("");
        setMobileNumber("");
        setGmail("");
        setMessage("");
      }
    } catch (error) {
      toast.error("Error submitting form. Please try again!");
      console.error("API Error:", error);
    }
  };

  return (
    <section className="sec10home m">
      <div className="m0 col-10">
        <h2 className="secsion10h2 fsh2 m0 mb2">WE GROW TOGETHER</h2>
        <p className="secsion10h2p mb2 fsp">
          Our people are the soul of MPeoples—passionate, creative, and always
          pushing boundaries. We grow together, support each other, and turn
          ideas into impact. More than a team, we’re a family shaping success
          with heart and vision.
        </p>
      </div>
      <div className="builder2">
        <img
          src="/images/des1.webp"
          alt=""
          className="sec10img1"
          loading="lazy"
        />
        <div>
          <img
            src="/images/girl-optimized.webp" // Use optimized version
            srcSet="/images/girl.webp 400w,
            /images/girl.webp 800w,
            /images/girl.webp 1200w"
            sizes="(max-width: 768px) 90vw,
           (max-width: 1200px) 50vw,
           800px"
            alt="Young woman portrait" // Descriptive alt text
            loading="lazy" // Lazy loading
            className="sec10img2"
            width={800} // Intrinsic width
            height={1200} // Intrinsic height
          />
        </div>
        <div className="sec10img3">
          <p className="sec10imgp fsp ">
            Ready for fresh perspectives and connections?
          </p>
          <h1 className="fsh3" style={{ color: "white", width: "500px" }}>
            Join us for a free consultation
          </h1>

          <form
            onSubmit={handleSubmit}
            className="d-flex flex-column gap-2 justify-content-center align-items-center"
          >
            <div className="sec10input1">
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="Enter First Name"
                className="sec10input2"
                required
              />
            </div>

            <div className="sec10input1">
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Enter Last Name"
                className="sec10input2"
                required
              />
            </div>

            <div className="sec10input1">
              <input
                type="tel"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                placeholder="Enter Mobile Number"
                className="sec10input2"
              />
            </div>

            <div className="sec10input3">
              <input
                className="sec10input4"
                type="email"
                value={gmail}
                onChange={(e) => setGmail(e.target.value)}
                placeholder="Enter Gmail"
                required
              />
            </div>

            <div className="sec10input3">
              <textarea
                className="sec10input4"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Message"
              />
            </div>

            <button type="submit" className="button">
              <span className="text">Let's Talk &rarr;</span>
              <div className="circle"></div>
            </button>
          </form>
        </div>
        <div className="sec10code4">
          <img className="sec10code5" src="/images/des2.webp" alt="" loading="lazy" />
          <img
            className="sec10code6"
            src="/images/des3.webp"
            alt=""
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
